/**
 * Колонки расширенного режима.
 * №, Дата, Документ и Организация закреплены слева, TRAILING_COLUMNS — справа.
 * Между ними — CONFIGURABLE_COLUMNS: пользователь выбирает их и порядок в «Настроить колонки».
 *
 * type: text (по умолчанию) | link | number | amount | source
 * side: dt — дебет, kt — кредит (группировка в списке доступных полей)
 */
export const CONFIGURABLE_COLUMNS = [
  { key: "accountDt", label: "Счет Дт", side: "dt" },
  { key: "accountKt", label: "Счет Кт", side: "kt" },
  { key: "articleOpiuDt", label: "Статья ОПИУ Дт", side: "dt" },
  { key: "articleOpiuKt", label: "Статья ОПИУ Кт", side: "kt" },
  { key: "cfoOpiuDt", label: "ЦФО ОПИУ Дт", side: "dt" },
  { key: "cfoOpiuKt", label: "ЦФО ОПИУ Кт", side: "kt" },
  { key: "articleDdsDt", label: "Статья ДДС Дт", side: "dt" },
  { key: "articleDdsKt", label: "Статья ДДС Кт", side: "kt" },
  { key: "cfoDdsDt", label: "ЦФО ДДС Дт", side: "dt" },
  { key: "cfoDdsKt", label: "ЦФО ДДС Кт", side: "kt" },
  { key: "projectDt", label: "Проект Дт", side: "dt" },
  { key: "projectKt", label: "Проект Кт", side: "kt" },
  { key: "departmentDt", label: "Отделение Дт", side: "dt" },
  { key: "departmentKt", label: "Отделение Кт", side: "kt" },
  { key: "counterpartyDt", label: "Контрагент Дт", side: "dt" },
  { key: "counterpartyKt", label: "Контрагент Кт", side: "kt" },
  { key: "employeeDt", label: "Сотрудник Дт", side: "dt" },
  { key: "employeeKt", label: "Сотрудник Кт", side: "kt" },
  { key: "contractDt", label: "Договор Дт", side: "dt", type: "link" },
  { key: "contractKt", label: "Договор Кт", side: "kt", type: "link" },
  { key: "nomenclatureDt", label: "Номенклатура Дт", side: "dt" },
  { key: "nomenclatureKt", label: "Номенклатура Кт", side: "kt" },
  { key: "fixedAssetDt", label: "Основное средство Дт", side: "dt" },
  { key: "fixedAssetKt", label: "Основное средство Кт", side: "kt" },
  { key: "intangibleAssetDt", label: "Нематериальный актив Дт", side: "dt" },
  { key: "intangibleAssetKt", label: "Нематериальный актив Кт", side: "kt" },
  { key: "cashAccountDt", label: "Денежный счет Дт", side: "dt" },
  { key: "cashAccountKt", label: "Денежный счет Кт", side: "kt" },
  { key: "workTypeDt", label: "Вид работ Дт", side: "dt" },
  { key: "workTypeKt", label: "Вид работ Кт", side: "kt" },
];

export const TRAILING_COLUMNS = [
  { key: "quantity", label: "Количество", type: "number", sortable: true },
  { key: "amount", label: "Сумма", type: "amount", sortable: true },
  {
    key: "source",
    label: "Источник / Тип данных",
    type: "source",
    sortable: true,
  },
  { key: "budgetVersion", label: "Версия бюджета", sortable: true },
  { key: "comment", label: "Комментарий" },
];

export const COLUMN_BY_KEY = Object.fromEntries(
  CONFIGURABLE_COLUMNS.map((column) => [column.key, column])
);

export const DEFAULT_COLUMN_ORDER = CONFIGURABLE_COLUMNS.map(
  (column) => column.key
);
